export default __webpack_public_path__ + "static/professor-2-af0eca407bfb796d596d84c67c7f1ae0.png";